<div class="px-8 h-screen overflow-y-auto pb-8">


  <div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Configuração/Parâmetros da Empresa</h1>
    </div>
</div>

  <div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <p-tabs value="0">
      <p-tablist>
        <div class="flex justify-between w-full">
        <div class="flex items-center justify-between">
          <p-tab value="0"><i class="pi pi-building"></i>Principal</p-tab>
          <p-tab value="1"><i class="pi pi-cog"></i>Configurações</p-tab>
          <p-tab value="2"><i class="pi pi-th-large"></i>Módulos</p-tab>
        </div>
      </div>
      </p-tablist>
      
      <p-tabpanels>
      <p-tabpanel value="0">
        <!-- Dados Gerais -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Dados Gerais</h3>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div class="md:col-span-2">
              <label class="block mb-1 font-medium">Razão Social <span class="text-red-500">*</span></label>
              <div class="flex flex-col">
                <input
                  pInputText
                  formControlName="name"
                  placeholder="Digite a razão social"
                  class="w-full"
                />
                <small class="text-red-500" *ngIf="isFieldInvalid('name')">Razão social é obrigatória</small>
              </div>
            </div>

            <div>
              <label class="block mb-1 font-medium">CNPJ</label>
              <input
                pInputText
                formControlName="cnpj"
                placeholder="00.000.000/0000-00"
                class="w-full"
              />
            </div>

            <div>
              <label class="block mb-1 font-medium">Inscrição Estadual</label>
              <input
                pInputText
                formControlName="ie"
                placeholder="Digite a inscrição estadual"
                class="w-full"
              />
            </div>
          </div>
        </div>

        <!-- Contato -->
        <div class="space-y-4 mt-6">
          <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Contato</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block mb-1 font-medium">Telefone</label>
              <input
                pInputText
                formControlName="phone"
                placeholder="(00) 0000-0000"
                class="w-full"
              />
            </div>

            <div>
              <label class="block mb-1 font-medium">Email</label>
              <input
                pInputText
                type="email"
                formControlName="email"
                placeholder="contato@empresa.com"
                class="w-full"
              />
            </div>
          </div>
        </div>

        <!-- Endereço -->
        <div class="space-y-4 mt-6">
          <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Endereço</h3>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div>
              <label class="block mb-1 font-medium">CEP</label>
              <div class="flex flex-col">
                <input
                  pInputText
                  formControlName="zipCode"
                  placeholder="00000-000"
                  class="w-full"
                />
              </div>
            </div>

            <div class="md:col-span-2">
              <label class="block mb-1 font-medium">Logradouro</label>
              <input
                pInputText
                formControlName="address"
                placeholder="Digite o logradouro"
                class="w-full"
              />
            </div>

            <div>
              <label class="block mb-1 font-medium">Número</label>
              <input
                pInputText
                formControlName="addressNumber"
                placeholder="Digite o número"
                class="w-full"
              />
            </div>
          </div>

          <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
            <div>
              <label class="block mb-1 font-medium">Complemento</label>
              <input
                pInputText
                formControlName="complement"
                placeholder="Digite o complemento"
                class="w-full"
              />
            </div>

            <div>
              <label class="block mb-1 font-medium">Bairro</label>
              <input
                pInputText
                formControlName="district"
                placeholder="Digite o bairro"
                class="w-full"
              />
            </div>

            <div>
              <label class="block mb-1 font-medium">Estado <span class="text-red-500">*</span></label>
              <div class="flex flex-col">
                <p-select
                  formControlName="state"
                  [options]="states"
                  optionLabel="description"
                  optionValue="acronym"
                  placeholder="Selecione o estado"
                  class="w-full"
                  [filter]="true"
                  (onChange)="getCities($event)"
                ></p-select>
                <small class="text-red-500" *ngIf="isFieldInvalid('state')">Estado é obrigatório</small>
              </div>
            </div>

            <div>
              <label class="block mb-1 font-medium">Cidade <span class="text-red-500">*</span></label>
              <div class="flex flex-col">
                <p-select
                  formControlName="city"
                  [options]="cities"
                  optionLabel="description"
                  optionValue="description"
                  placeholder="Selecione a cidade"
                  class="w-full"
                  [filter]="true"
                  [disabled]="!form.get('state')?.value"
                ></p-select>
                <small class="text-red-500" *ngIf="isFieldInvalid('city')">Cidade é obrigatória</small>
              </div>
            </div>
          </div>
        </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="space-y-4">
            <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Configurações financeiras</h3>

            <div class="flex flex-wrap items-center gap-x-3 gap-y-2">
              <p-checkbox formControlName="financialChargeInterest" inputId="finChargeInterest" binary="true"></p-checkbox>
              <label for="finChargeInterest" class="font-medium text-gray-800 cursor-pointer">Cobrar juros na quitação de parcelas em atraso</label>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-3 max-w-5xl items-end">
              <div class="flex flex-col min-w-0">
                <label class="block mb-1 text-sm font-medium">% juros ao mês</label>
                <p-inputNumber
                  formControlName="financialInterestMonthlyPercent"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [min]="0"
                  [max]="100"
                  suffix=" %"
                  class="w-full"
                ></p-inputNumber>
              </div>

              <div class="flex flex-col min-w-0">
                <label class="block mb-1 text-sm font-medium">Tipo de juros</label>
                <p-select
                  formControlName="financialInterestCompound"
                  [options]="interestTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  class="w-full"
                ></p-select>
              </div>

              <div class="flex flex-col min-w-0">
                <label class="block mb-1 text-sm font-medium">Carência (dias após venc.)</label>
                <p-inputNumber
                  formControlName="financialInterestGraceDays"
                  [min]="0"
                  [max]="3650"
                  [useGrouping]="false"
                  class="w-full"
                ></p-inputNumber>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="2">
          <div class="space-y-4">
            <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Módulos da Empresa</h3>
            <p class="text-sm text-gray-500">
              Selecione os módulos que a aplicação poderá acessar para esta empresa.
            </p>

            <div *ngIf="isLoadingModules" class="text-sm text-gray-500">Carregando módulos...</div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <button
                type="button"
                *ngFor="let module of companyModules"
                (click)="toggleModuleCard(module)"
                class="w-full text-left border rounded-md px-5 py-4 flex items-center justify-between transition-colors shadow-sm"
                [ngClass]="module.enabled
                  ? 'border-orange-300 bg-orange-50 text-orange-800'
                  : 'border-gray-300 bg-white text-gray-700 hover:border-orange-300'"
              >
                <span class="font-medium text-base">{{ module.name }}</span>
                <span
                  class="w-6 h-6 border-2 rounded-sm flex items-center justify-center"
                  [ngClass]="module.enabled ? 'border-orange-600' : 'border-gray-400'"
                >
                  <i *ngIf="module.enabled" class="pi pi-check text-xs text-orange-600"></i>
                </span>
              </button>
            </div>

            <div class="flex justify-end pt-2">
              <p-button
                label="Salvar Módulos"
                icon="pi pi-save"
                severity="secondary"
                (onClick)="saveCompanyModules()"
                [disabled]="isLoadingModules || companyModules.length === 0"
                [loading]="isSavingModules">
              </p-button>
            </div>
          </div>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

 <!-- Botões -->
    <div class="flex justify-end gap-3">
      <button (click)="goBack()" type="button" class="border px-2 border-orange-500 cursor-pointer rounded">Cancelar</button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
      >
        {{ isEditMode ? 'Salvar' : 'Cadastrar' }}
      </button>
    </div>
  </form>
</div>

<p-toast></p-toast>
 
</div>


